import { createFileRoute } from "@tanstack/react-router";
import { ServiceAccountDetail } from "../../../features/settings/serviceaccount-detail";

export const Route = createFileRoute("/_authed/$org/$project/serviceaccounts/$name")({ component: ServiceAccountPage });

function ServiceAccountPage() {
  const { org, project, name } = Route.useParams();
  return <ServiceAccountDetail scope={{ org, project }} name={name} />;
}
